module.exports = __webpack_public_path__ + "img/flexepin.d214496d.png";